import Channels from '../base/channels';
import Env from '../base/env';
import Component from 'gia/Component';
import FilterActions from '../common/FilterActions';
import loadComponents from 'gia/loadComponents';
import RevealGridItem from '../fx/RevealGridItem';


export default class Module extends Component
{

  mount() {
    this.DOM = {}
    this.DOM.view = this.element
    this.DOM.receptor = this.DOM.view.querySelector('.jsFilter--receptor')
    this.actions = new FilterActions(this.DOM.view)
    this.actions.setup()
    this.fnGridUpdate = this.update.bind(this)
    this.fnGridPosition = this.reposScroll.bind(this)
    Channels.on('grid::update',this.fnGridUpdate)
    Channels.on('grid::repos',this.fnGridPosition)
  }

  reposScroll()
  {
    //! Repos Scroll
    const getScrollPos = (Env.framework.toolbox.scrollPosition().scrollY + this.DOM.view.getBoundingClientRect().top)
    if(Env.framework.toolbox.scrollPosition().scrollY > 0) {
      window.scrollTo(0, 100);
    }
  }

  redrawGrid()
  {
    setTimeout(() => {
      if(typeof Env.framework.UI.smoothie != 'undefined') {
        Env.framework.UI.smoothie.update()
      }
      //! Redraw FX components
      setTimeout(() => {
        loadComponents({
          "RevealGridItem": RevealGridItem
        },this.DOM.receptor);
      }, 100);
    }, 100);
  }

  update()
  {
    this.redrawGrid()
  }

  unmount()
  {
    Channels.removeListener('grid::update',this.fnGridUpdate)
    Channels.removeListener('grid::repos',this.fnGridPosition)
    this.actions.destroy()
  }
}
